
  export const THREADS_RECEIVED = "THREADS_RECEIVED";
  export const SET_THREAD = "SET_THREAD";
  export const CREATE_THREAD = "CREATE_THREAD";
  export const SET_PROPERTY_THREAD = "SET_PROPERTY_THREAD";
  